import 'babel-polyfill'
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App'
import i18n from './plugins/i18n'
import './plugins/ga'
import './plugins/vuetify'
import router from './router.js'
import ajax from './services/ajax.js'
import toastr from './services/toastr.js'
import url from './services/url.js'
import store from './store.js'

export default {
  run () {
    Vue.config.productionTip = false

    sync(store, router)

    Vue.prototype.$toastr = toastr
    Vue.prototype.$ajax = ajax
    Vue.prototype.$url = url

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      i18n,
      components: { App },
      template: '<App/>'
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/bootstrap.js